import { API } from "./data";

const DEFAULT_PHONE = "201223241195";
let cachedPhone = null;
let pending = null;

export async function fetchWhatsAppPhone() {
  if (cachedPhone) return cachedPhone;
  if (pending) return pending;

  pending = fetch(`${API}/settings/whatsapp`)
    .then((res) => (res.ok ? res.json() : null))
    .then((data) => {
      cachedPhone = data?.phone || DEFAULT_PHONE;
      return cachedPhone;
    })
    .catch(() => {
      cachedPhone = DEFAULT_PHONE;
      return cachedPhone;
    })
    .finally(() => {
      pending = null;
    });

  return pending;
}

export function whatsappLink(phone, text = "start conversation") {
  const cleaned = String(phone || DEFAULT_PHONE).replace(/[^\d]/g, "");
  return `https://api.whatsapp.com/send/?phone=${cleaned}&text=${encodeURIComponent(
    text
  )}&app_absent=0`;
}

export { DEFAULT_PHONE };
